import { QueryRunResource } from '../query-runs/query-run-response.types';

export const PRODUCER_RUN_RESOURCE_PROPERTIES: readonly string[] = [
  'data_source_id',
  'limit',
  'raw_source',
  'rendered_source',
  'token',
  'spreadsheet_name',
  'worksheet_name',
  'owned_by',
  'spreadsheet_url',
  'worksheet_range',
  'connected_by',
];

// DataRunResource is the same as QueryRunResource
// This might change in the future but for now they are equal
export type DataRunResource = QueryRunResource;

export type EmbeddedDataRunsResponse = {
  _embedded: {
    data_runs: DataRunResource[];
  };
};
